import { useLayoutEffect, useState } from 'react';
import type { MutableRefObject, RefObject } from 'react';

export function useMeasuredRect(
  activeId: string | null,
  refs: MutableRefObject<Record<string, HTMLButtonElement | null>>,
  containerRef: RefObject<HTMLElement | null>,
) {
  const [rect, setRect] = useState({ height: 0, left: 0, top: 0, width: 0 });

  useLayoutEffect(() => {
    let cancelled = false;
    const update = () => {
      if (cancelled) return;
      const element = activeId ? refs.current[activeId] : null;
      const container = containerRef.current;
      if (!element || !container) return;
      const item = element.getBoundingClientRect();
      const parent = container.getBoundingClientRect();
      setRect({
        height: item.height,
        left: item.left - parent.left,
        top: item.top - parent.top,
        width: item.width,
      });
    };
    update();
    const observer = new ResizeObserver(update);
    if (containerRef.current) observer.observe(containerRef.current);
    if (activeId && refs.current[activeId]) {
      observer.observe(refs.current[activeId]!);
    }
    document.fonts?.ready.then(update);
    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, [activeId, containerRef, refs]);

  return rect;
}
